export default "__VITE_ASSET__Dimms0EL__"